import { createSelector } from 'reselect';

import searchItems from 'utils/searchItems';

import { getDebouncedSearchValue } from 'store/search/selectors';

import { getSystem } from './system.selectors';

const selectAppraisalProducts = createSelector(
  getSystem,
  ({ appraisalProducts }) => appraisalProducts,
);

export const selectAppraisalProductsList = createSelector(
  selectAppraisalProducts,
  ({ appraisalProducts }) => appraisalProducts,
);

export const selectMercuryProducts = createSelector(
  selectAppraisalProducts,
  ({ mercuryProducts }) => mercuryProducts,
);

export const selectReggoraProducts = createSelector(
  selectAppraisalProducts,
  ({ reggoraProducts }) => reggoraProducts,
);

export const selectHomeVisionJobTypes = createSelector(
  selectAppraisalProducts,
  ({ homeVisionJobTypes }) => homeVisionJobTypes,
);

export const selectAppraisalProductsValues = createSelector(
  selectAppraisalProductsList,
  Object.values,
);

export const selectFilteredAppraisalProducts = createSelector(
  getDebouncedSearchValue,
  selectAppraisalProductsValues,
  searchItems(({ name }) => [name]),
);
